enum PATIENTS_ACTION_TYPES {
  'patient_add_begins' = 'patient_add_begins',
  'patient_add_success' = 'patient_add_success',
  'patient_add_error' = 'patient_add_error',
  'get_all_patients_begins' = 'get_all_patients_begins',
  'get_all_patients_success' = 'get_all_patients_success',
  'get_all_patients_error' = 'get_all_patients_error',
  'get_current_patient_begins' = 'get_current_patient_begins',
  'get_current_patient_success' = 'get_current_patient_success',
  'get_current_patient_error' = 'get_current_patient_error',
  'set_current_patient_begins' = 'set_current_patient_begins',
  'set_current_patient_success' = 'set_current_patient_success',
  'set_current_patient_error' = 'set_current_patient_error',
  'update_current_patient' = 'update_current_patient',
  'add_care_professional_success' = 'add_care_professional_success',
  'get_reports_success' = 'get_reports_success',
  'get_reports_error' = 'get_reports_error',
  'add_report_success' = 'add_report_success',
  'add_report_error' = 'add_report_error',
  'update_report' = 'update_report',
  'save_new_patient' = 'save_new_patient',
  'set_passed_base_form' = 'set_passed_base_form',
  'set_passed_games' = 'set_passed_games',
  'delete_child_start' = 'delete_child_start',
  'delete_child_success' = 'delete_child_success',
  'delete_child_error' = 'delete_child_error',
  'clear' = 'children_clear',
  'set_curr_child' = 'set_curr_child',
  'set_questionnaries_in_row' = 'set_questionnaries_in_row',
  'set_talents_chart_map' = 'set_talents_chart_map',
  'set_answers' = 'set_answers',
  'set_current_assessment' = 'set_current_assessment',
  'clear_answers' = 'clear_answers'
}
export default PATIENTS_ACTION_TYPES



// WEBPACK FOOTER //
// ./src/store/patients/types.ts